import { useDispatch } from "react-redux";
import { useToasts } from "./useToasts";
import useMediaQuery from "./utils";
import {
  setError,
  setInfo,
  setLoading,
  setOk,
} from "@store/globalNotifications/actions";

export const useGlobalNotifs = () => {
  const isTablet = useMediaQuery("max", 1024);
  const { success, error, info, loading } = useToasts();
  const dispatch = useDispatch();

  const onSuccess = (str: string, svg = true) => {
    if (isTablet) {
      success(str);
      return;
    }
    dispatch(setOk(str));
  };

  const onInfo = (str: string, svg = true) => {
    if (isTablet) {
      info(str);
      return;
    }
    dispatch(setInfo(str));
  };

  const onError = (str: string, svg = true, timer?: number) => {
    if (isTablet) {
      error(str);
      return;
    }
    dispatch(
      setError({
        text: str,
        timer,
      })
    );
  };

  const onLoader = (bool: boolean) => {
    dispatch(setLoading(bool));
    // loading(bool);
  };

  return {
    onSuccess,
    onInfo,
    onError,
    onLoader,
  };
};
